<template>
    <div class="container">
        <b-modal
            :model-value="modEditarSubmenu"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
         @hide="cierraModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formulario.nombre" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre del submenú"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.description }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formulario.descripcion" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Descripción del submenú"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.route }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formulario.ruta" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="/ruta-del-submenú"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.orden }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="formulario.orden" 
                            type="number" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Número de orden"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.menu }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select 
                            v-model="formulario.id_menu" 
                            class="form-input"
                        >
                            <option value="" disabled>Seleccione un menú</option>
                            <option
                                v-for="menu in listaMenu"
                                :key="menu.id" 
                                :value="menu.id" 
                            >
                                {{ menu?.nombre }} 
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardarSubMenu">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import SubMenu from '../../../services/SubMenu'; 

export default {
    name: "EditarSubmenu",
    props: ['modEditarSubmenu', 'item'],
    data: () => ({
        listaMenu: [],
        formulario: {
            id: "",
            nombre: "",
            descripcion: "",
            ruta: "",
            orden: "",
            id_menu: null
        },
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Editar submenú",
                    name: "Nombre",
                    description: "Descripción",
                    route: "Ruta",
                    menu: "Menú",
                    save: "Guardar",
                    close: "Cerrar",
                    orden: "Orden",
                    infoTitle: "Datos del submenú",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            } else {
                return {
                    title: "Edit submenu",
                    name: "Name",
                    description: "Description",
                    route: "Route",
                    menu: "Menu",
                    save: "Save",
                    close: "Close",
                    orden: "Order",
                    infoTitle: "Submenu information",
                    infoText: "Update the information and save changes."
                }
            }
        }
    },
    methods: {
        guardarSubMenu() {
            const submenuId = this.formulario.id || this.normalizarItem(this.item)?.id
            
            let dataForm = {
                'id': submenuId,
                'nombre': this.formulario.nombre,
                'descripcion': this.formulario.descripcion,
                'ruta': this.formulario.ruta,
                'menu': this.formulario.id_menu,
                'orden': this.formulario.orden,
                'idUser': this.$store.state.userId,
            }

            if (this.formulario.nombre == "") {
                this.$toast.error('Diligenciar el campo nombre')
                return
            }
            if (this.formulario.descripcion == "") {
                this.$toast.error('Diligenciar el campo descripción')
                return
            }
            if (this.formulario.ruta == "") {
                this.$toast.error('Diligenciar el campo ruta')
                return
            }
            if (this.formulario.id_menu == "" || this.formulario.id_menu == null) {
                this.$toast.error('Seleccionar un menú')
                return
            }
            if (this.formulario.orden == "") {
                this.$toast.error('Diligenciar el campo Orden')
                return
            }

            SubMenu.updateSubmenu(dataForm)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.$emit('updated', {
                            id: submenuId,
                            nombre: this.formulario.nombre,
                            descripcion: this.formulario.descripcion,
                            ruta: this.formulario.ruta,
                            id_menu: this.formulario.id_menu,
                            orden: this.formulario.orden
                        })
                        this.cierraModal()
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error('Error al actualizar el submenú')
                })
        },
        cierraModal() {
            this.$emit('cierraModal', false)
            this.formulario = {
                id: "",
                nombre: "",
                descripcion: "",
                ruta: "",
                orden: "",
                id_menu: null
            }
        },
        normalizarItem(item) {
            if (Array.isArray(item)) {
                return item[0] || null
            }
            return item || null
        }
    },
    mounted() {
        Menu.getAllMenu()
            .then((res) => {
                this.listaMenu = res.data.listMenu
            })
            .catch((err) => console.log(err))
    },
    watch: {
        item: {
            immediate: true,
            deep: true,
            handler(nuevoItem) {
                const data = this.normalizarItem(nuevoItem)
                if (data) {
                    this.formulario = {
                        id: data.id || "",
                        nombre: data.nombre || "",
                        descripcion: data.descripcion || "",
                        ruta: data.ruta || "",
                        orden: data.orden ?? "",
                        id_menu: data.id_menu ?? null
                    }
                }
            }
        }
    }
}
</script>